<template>
  <el-dialog
    :title="$t('communityManage.addCommunity')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="addCommunityInfo" label-width="120px" :rules="rules" ref="addCommunityForm">
      <el-form-item :label="$t('communityManage.name')" prop="name">
        <el-input
          v-model="addCommunityInfo.name"
          :placeholder="$t('communityManage.namePlaceholder')"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('communityManage.area')">
        <el-select
          v-model="selectProv"
          :placeholder="$t('communityManage.provincePlaceholder')"
          style="width: 30%"
          @change="getProv"
        >
          <el-option
            v-for="item in provs"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>

        <el-select
          v-model="selectCity"
          :placeholder="$t('communityManage.cityPlaceholder')"
          style="width: 30%"
          @change="getCity"
          :disabled="!selectProv"
        >
          <el-option
            v-for="item in citys"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>

        <el-select
          v-model="selectArea"
          :placeholder="$t('communityManage.areaPlaceholder')"
          style="width: 30%"
          @change="getArea"
          :disabled="!selectCity"
        >
          <el-option
            v-for="item in areas"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('communityManage.address')" prop="tmpAddress">
        <el-input
          v-model="addCommunityInfo.tmpAddress"
          :placeholder="$t('communityManage.addressPlaceholder')"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('communityManage.nearbyLandmarks')" prop="nearbyLandmarks">
        <el-input
          v-model="addCommunityInfo.nearbyLandmarks"
          :placeholder="$t('communityManage.nearbyLandmarksPlaceholder')"
        ></el-input>
      </el-form-item>

      <template v-for="(item,index) in addCommunityInfo.attrs">
        <el-form-item
          :label="item.specName"
          :key="index"
          v-if="item.specType == '2233'"
        >
          <el-input
            v-model="item.value"
            :placeholder="item.specHoldplace"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="item.specName"
          :key="index"
          v-if="item.specType == '3344'"
        >
          <el-select
            v-model="item.value"
            :placeholder="item.specHoldplace"
            style="width: 100%"
          >
            <el-option
              v-for="value in item.values"
              :key="value.value"
              :label="value.valueName"
              :value="value.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveCommunityInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveCommunity, getAreas, getAttrSpec, getAttrValue } from '@/api/common/communityManage/communityManageApi'

export default {
  name: 'AddCommunity',
  data() {
    return {
      dialogVisible: false,
      addCommunityInfo: {
        name: '',
        address: '',
        tmpAddress: '',
        areaAddress: '',
        nearbyLandmarks: '',
        cityCode: '',
        mapX: '101.33',
        mapY: '101.33',
        attrs: []
      },
      areas: [],
      provs: [],
      citys: [],
      selectProv: '',
      selectCity: '',
      selectArea: '',
      rules: {
        name: [
          { required: true, message: this.$t('communityManage.nameRequired'), trigger: 'blur' },
          { min: 1, max: 20, message: this.$t('communityManage.nameLength'), trigger: 'blur' }
        ],
        tmpAddress: [
          { required: true, message: this.$t('communityManage.addressRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('communityManage.addressMaxLength'), trigger: 'blur' }
        ],
        nearbyLandmarks: [
          { required: true, message: this.$t('communityManage.nearbyLandmarksRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('communityManage.nearbyLandmarksMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._loadCommunityAttrSpec()
      this._initArea('101', '0')
    },
    handleClose() {
      this.$refs.addCommunityForm.resetFields()
      this.clearAddCommunityInfo()
    },
    saveCommunityInfo() {
      this.$refs.addCommunityForm.validate(valid => {
        if (!valid) return
        
        this.addCommunityInfo.address = this.addCommunityInfo.areaAddress + this.addCommunityInfo.tmpAddress
        
        saveCommunity(this.addCommunityInfo).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('saved')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          console.error('请求失败:', error)
          this.$message.error(this.$t('common.saveFailed'))
        })
      })
    },
    clearAddCommunityInfo() {
      this.addCommunityInfo = {
        name: '',
        address: '',
        tmpAddress: '',
        nearbyLandmarks: '',
        cityCode: '0971',
        mapX: '101.33',
        mapY: '101.33',
        attrs: []
      }
    },
    getProv(prov) {
      this._initArea('202', prov)
    },
    getCity(city) {
      console.log(city)
      this._initArea('303', city)
    },
    getArea(area) {
      this.addCommunityInfo.cityCode = area
      this.addCommunityInfo.areaAddress = ''
      
      if (this.provs == null || this.provs == undefined) return
      
      this.provs.forEach(param => {
        if (param.areaCode == this.selectProv) {
          this.addCommunityInfo.areaAddress = param.areaName
        }
      })
      
      this.citys.forEach(param => {
        if (param.areaCode == this.selectCity) {
          this.addCommunityInfo.areaAddress += param.areaName
        }
      })
      
      this.areas.forEach(param => {
        if (param.areaCode == this.selectArea) {
          this.addCommunityInfo.areaAddress += param.areaName
        }
      })
    },
    _initArea(areaLevel, parentAreaCode) {
      getAreas({
        areaLevel,
        parentAreaCode
      }).then(res => {
        const tmpAreas = res
        if (areaLevel == '101') {
          this.provs = tmpAreas
        } else if (areaLevel == '202') {
          this.citys = tmpAreas
        } else {
          this.areas = tmpAreas
        }
      }).catch(error => {
        console.error('请求失败:', error)
        this.$message.error('查询地区失败')
      })
    },
    _loadCommunityAttrSpec() {
      this.addCommunityInfo.attrs = []
      getAttrSpec('building_community_attr').then(data => {
        data.forEach(item => {
          item.value = ''
          if (item.specShow == 'Y') {
            item.values = []
            this._loadAttrValue(item.specCd, item.values)
            this.addCommunityInfo.attrs.push(item)
          }
        })
      })
    },
    _loadAttrValue(specCd, values) {
      getAttrValue(specCd).then(data => {
        data.forEach(item => {
          if (item.valueShow == 'Y') {
            values.push(item)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.el-select {
  margin-right: 10px;
}
</style>